import script from "./TimerToast.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimerToast.vue?vue&type=script&setup=true&lang=ts"

import "./TimerToast.vue?vue&type=style&index=0&id=6eb053b2&lang=css"

const __exports__ = script;

export default __exports__